/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { ComponentType, ClassAttributes, HTMLAttributes } from 'react';
import { styled, type StyledProps } from '@compiled/react';

/**
 * Visible only to screenreaders. Use when there is a need
 * to provide more context to a non-sighted user.
 * Styled copied from @atlaskit/visually-hidden
 */
export const visuallyHiddenStyles = {
	width: '1px',
	height: '1px',
	padding: 0,
	position: 'absolute',
	border: '0',
	clip: 'rect(1px, 1px, 1px, 1px)',
	overflow: 'hidden',
	whiteSpace: 'nowrap',
} as const;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ScreenReaderText: ComponentType<
	ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values
> = styled.div(visuallyHiddenStyles);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ScreenReaderCaption: ComponentType<
	ClassAttributes<HTMLElement> & HTMLAttributes<HTMLElement> & StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values
> = styled.caption(visuallyHiddenStyles);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ScreenReaderLegend: ComponentType<
	ClassAttributes<HTMLLegendElement> & HTMLAttributes<HTMLLegendElement> & StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values
> = styled.legend(visuallyHiddenStyles);
